'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-lg">
            <div className="text-sm text-center sm:text-left">
                <p>
                    We use cookies to improve your experience and analyze site traffic. By continuing to use this site, you agree to our use of cookies.
                    {' '}
                    <Link href="/policies" className="underline hover:text-gray-300">
                        Learn more
                    </Link>.
                </p>
            </div>
            <button
                onClick={acceptCookies}
                className="bg-white text-gray-900 px-6 py-2 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
                Accept
            </button>
        </div>
    );
}
